import {Input, Modal, Row, Select, Table, Button, Tag, Tooltip} from "antd";
import React, {useEffect, useState} from "react";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {useStore} from "../../../hooks/useStore";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {useFetch} from "../../../hooks/useFetch";
import {ClickableSpan} from "../../pools/poolIntensities/responsiveDataTable/ResponsiveDataTable.styles";
import OrderTransferCenterModal from "./orderTransferCenterModal/OrderTransferCenterModal";
import styled from "styled-components";
import {DeleteOutlined} from "@ant-design/icons";

// Styled components
const SelectedCentersContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const CenterTag = styled(Tag)`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    margin: 0;

    .anticon {
        cursor: pointer;
        &:hover {
            color: #ff4d4f;
        }
    }
`;

const VALID_STATUSES = ["created"];

const PlanningDraft = () => {
    const history = useHistory();
    const stores = useStore();
    const [isOpenOrderTransferCenterModal, setIsOpenOrderTransferCenterModal] = useState(false);
    const [transferReferenceData, setTransferReferenceData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [returnLoading, setReturnLoading] = useState(false);

    const [transferReferenceLoading, transferReference] = useFetch({
        fetchFn: () => {
            const queryParams = new URLSearchParams(history.location.search);
            const status = queryParams.get("status");

            if (!status || !VALID_STATUSES.includes(status)) {
                history.push("/transfers");
            }

            return stores.transferStore.getTransferReference({
                id: queryParams.get("id"),
                status
            });
        },
        loading: true,
        dependencies: [],
        callbackFunc: data => {
            setTransferReferenceData(data?.transferReference || []);
        }
    });

    const [transferRegionsLoading, transferRegions, _, __, refetchRegions] = useFetch({
        fetchFn: stores.transferStore.transfersRegions.bind(),
        loading: true,
        dependencies: []
    });

    const [
        createRotationLoading,
        createRotationResult,
        _____,
        ______,
        createRotationRefetch
    ] = useFetch({
        fetchFn: () =>
            stores.transferStore.createRotation({
                parts: transferReferenceData.map(item => ({
                    partId: item._id,
                    nextTransfers: [
                        ...(item?.nextTransferCenters || []).map(({to, type}) => ({to, type})),
                        {type: "lastMile", courierType: item?.lastmileCourierType}
                    ]
                }))
            }),
        loading: true,
        initialCall: false,
        dependencies: [],
        callbackFunc: data => {
            if (data.result && data.result.length > 0) {
                const queryParams = new URLSearchParams(history.location.search);
                queryParams.set("status", "calculated");
                history.push(`/transfers/calculated-transfer?${queryParams.toString()}`);
            }
        }
    });

    const cancelRotation = async () => {
        try {
            setReturnLoading(true);
            const transferReferenceId = new URLSearchParams(history.location.search).get("id");
            const rotateCancel = await stores.transferStore.returnTranferReferenceEdit({
                transferReferenceId
            });
            return rotateCancel;
        } catch (error) {
            console.log(error);
        } finally {
            setReturnLoading(false);
            history.push("/transfers");
        }
    };

    const confirmModal = ({description, key}) => {
        const hasEmptyLastmileCourierType = transferReferenceData.some(
            item => !item.lastmileCourierType
        );

        if (key === "create" && hasEmptyLastmileCourierType) {
            Modal.error({
                title: "Hata",
                content: "Lütfen tüm satırlar için lastmile kurye tipini seçiniz.",
                okText: "Tamam"
            });
            return;
        }

        Modal.confirm({
            title: "Onaylıyor musunuz?",
            icon: <ExclamationCircleOutlined />,
            content: description,
            okText: "Evet",
            onOk: () => {
                if (key === "create") {
                    createRotationRefetch();
                } else {
                    cancelRotation();
                }
            },
            cancelText: "Hayır"
        });
    };

    const handleDeleteCenter = (recordId, centerId) => {
        setTransferReferenceData(prev =>
            prev.map(item => {
                if (item._id === recordId) {
                    return {
                        ...item,
                        nextTransferCenters: (item.nextTransferCenters || []).filter(
                            center => center.id !== centerId
                        )
                    };
                }
                return item;
            })
        );
    };

    return (
        <>
            <h2>Taslak Planlama</h2>
            <Row style={{justifyContent: "flex-end", marginBottom: "10px", gap: "10px"}}>
                <div>
                    <CustomButton
                        onClick={() =>
                            confirmModal({
                                description: "Taslağı iptal etmek istediğinize emin misiniz?",
                                key: "cancel",
                                loading: returnLoading
                            })
                        }
                    >
                        Taslağı İptal Et
                    </CustomButton>
                </div>
                <div>
                    <CustomButton
                        onClick={() =>
                            confirmModal({
                                description: "Rotalama oluşturmak istediğinize emin misiniz?",
                                key: "create"
                            })
                        }
                        type="primary"
                    >
                        Rotalama Oluştur
                    </CustomButton>
                </div>
            </Row>
            <div>
                <Table
                    dataSource={transferReferenceData || []}
                    rowKey="_id"
                    pagination={{pageSize: 10}}
                    scroll={{x: "100%"}}
                    loading={transferReferenceLoading || createRotationLoading || returnLoading}
                >
                    <Table.Column
                        title="Yaka"
                        dataIndex="continent"
                        key="continent"
                        ellipsis
                        width={"200px"}
                        render={(continent, record) => (
                            <span>{record?.region?.continent || "-"}</span>
                        )}
                    />
                    <Table.Column
                        title="Şehir"
                        dataIndex="city"
                        key="city"
                        ellipsis
                        width={"200px"}
                        render={city => <span>{city}</span>}
                    />
                    <Table.Column
                        title="İlçe"
                        dataIndex="district"
                        key="district"
                        ellipsis
                        width={"200px"}
                        render={district => <span>{district}</span>}
                    />
                    <Table.Column
                        title="Bölge"
                        dataIndex="region"
                        key="region"
                        width="200px"
                        render={(region, record) => <span>{record?.region?.name || "-"}</span>}
                    />
                    <Table.Column
                        title="Grup Bilgisi"
                        dataIndex="transferGroups"
                        key="transferGroups"
                        width="300px"
                        render={transferGroups => (
                            <Tooltip
                                title={transferGroups?.map(group => group.name).join(", ") || "-"}
                            >
                                <div
                                    style={{
                                        whiteSpace: "nowrap",
                                        maxWidth: "300px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {transferGroups?.map(group => group.name).join(", ") || "-"}
                                </div>
                            </Tooltip>
                        )}
                    />
                    <Table.Column
                        width="200px"
                        title="Teslimat Sayısı"
                        dataIndex="totalShipments"
                        key="totalShipments"
                        render={totalShipments => <span>{totalShipments + " Adet" || "-"}</span>}
                    />
                    <Table.Column
                        width="200px"
                        title="Paket Sayısı"
                        dataIndex="totalPackageCount"
                        key="totalPackageCount"
                        render={totalPackages => <span>{totalPackages + " Paket" || "-"}</span>}
                    />
                    <Table.Column
                        width="300px"
                        title="Dağıtım Noktası"
                        dataIndex="transferCenter"
                        key="transferCenter"
                        render={(transferCenter, record) => (
                            <>
                                <ClickableSpan
                                    onClick={() => {
                                        setSelectedRowId(record._id);
                                        setIsOpenOrderTransferCenterModal(true);
                                    }}
                                >
                                    {record?.nextTransferCenters?.length > 0 ? "Düzenle" : "Sırala"}
                                </ClickableSpan>
                                {record?.nextTransferCenters?.length > 0 && (
                                    <SelectedCentersContainer>
                                        {record?.nextTransferCenters
                                            .sort((a, b) => a.order - b.order)
                                            .map((center, index) => (
                                                <CenterTag key={center.id}>
                                                    {index + 1}. {center.name}
                                                    <DeleteOutlined
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            handleDeleteCenter(
                                                                record._id,
                                                                center.id
                                                            );
                                                        }}
                                                    />
                                                </CenterTag>
                                            ))}
                                    </SelectedCentersContainer>
                                )}
                            </>
                        )}
                    />

                    <Table.Column
                        width="200px"
                        title="Midmile Kurye Tipi"
                        dataIndex="midmileCourierType"
                        key="midmileCourierType"
                        render={midmileCourierType => <span>Araç</span>}
                    />
                    {history.location.search.includes("status=calculated") && (
                        <Table.Column
                            width="200px"
                            title="Midmile Kurye Sayısı"
                            key={"midmileCourierNumber"}
                            dataIndex="midmileCourierNumber"
                            render={(midmileCourierNumber, record) => (
                                <Input
                                    disabled
                                    style={{width: "100%"}}
                                    type="number"
                                    min={0}
                                    value={midmileCourierNumber}
                                    onChange={e => {
                                        const newData = transferReferenceData.map(item => {
                                            if (item._id === record._id) {
                                                return {
                                                    ...item,
                                                    midmileCourierNumber: e.target.value
                                                };
                                            }
                                            return item;
                                        });
                                        setTransferReferenceData(newData);
                                    }}
                                />
                            )}
                        />
                    )}
                    <Table.Column
                        width="200px"
                        title="Lastmile Kurye Tipi"
                        key="lastmileCourierType"
                        dataIndex="lastmileCourierType"
                        render={(lastmileCourierType, record) => (
                            <Select
                                style={{width: "100%"}}
                                value={lastmileCourierType}
                                onChange={value => {
                                    const newData = transferReferenceData.map(item => {
                                        if (item._id === record._id) {
                                            return {
                                                ...item,
                                                lastmileCourierType: value
                                            };
                                        }
                                        return item;
                                    });
                                    setTransferReferenceData(newData);
                                }}
                            >
                                <Select.Option value="car">Araç</Select.Option>
                                <Select.Option value="motor">Motor</Select.Option>
                            </Select>
                        )}
                    />
                    {history.location.search.includes("status=calculated") && (
                        <Table.Column
                            width="200px"
                            title="Lastmile Kurye Sayısı"
                            key={"lastmileCourierNumber"}
                            dataIndex="lastmileCourierNumber"
                            render={(lastmileCourierNumber, record) => (
                                <Input
                                    disabled
                                    style={{width: "100%"}}
                                    min={0}
                                    value={lastmileCourierNumber}
                                    type="number"
                                    onChange={e => {
                                        const newData = transferReferenceData.map(item => {
                                            if (item._id === record._id) {
                                                return {
                                                    ...item,
                                                    lastmileCourierNumber: e.target.value
                                                };
                                            }
                                            return item;
                                        });
                                        setTransferReferenceData(newData);
                                    }}
                                />
                            )}
                        />
                    )}
                </Table>
                <OrderTransferCenterModal
                    isOpen={isOpenOrderTransferCenterModal}
                    onClose={() => setIsOpenOrderTransferCenterModal(false)}
                    nextTransferCenters={
                        transferReferenceData.find(item => item._id === selectedRowId)
                            ?.nextTransferCenters || []
                    }
                    onSave={centers => {
                        setTransferReferenceData(prev =>
                            prev.map(item => {
                                if (item._id === selectedRowId) {
                                    return {
                                        ...item,
                                        nextTransferCenters: centers
                                    };
                                }
                                return item;
                            })
                        );
                    }}
                />
            </div>
        </>
    );
};

export default PlanningDraft;
